<p-card class="p-card container" [class.proposal-section--valid]="isSectionCompleted()">
  <h3 i18n>Questionnaires supplémentaires</h3>

  @if (extraQuestionnaires.length > 0) {
    <div class="flex flex-wrap gap-3">
      @for (extraQuestionnaire of extraQuestionnaires; track extraQuestionnaire; let eqIndex = $index) {
        <div
          class="w-full layout__inner-card"
          [class.layout__inner-card--green-border]="
            !isSectionCompleted() &&
            extraQuestionnaire.status === QUESTIONNAIRE_STATUS.COMPLETE &&
            getFormGroup(eqIndex).valid
          ">
          <h3>{{ extraQuestionnaire.title }}</h3>
          @for (question of extraQuestionnaire.questions; track question; let i = $index; let last = $last) {
            <div class="flex">
              <div class="mr-2">{{ i + 1 }}.</div>
              <div class="flex-grow-1">
                <em-question
                  [question]="question"
                  [control]="getFormControl(eqIndex, question.answer.propertyName)"></em-question>
                @if (!last) {
                  <p-divider></p-divider>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <i class="text-600" i18n>Aucun questionnaire supplémentaire.</i>
  }
</p-card>
